import DiscountSection from "../../components/DiscountSection/DiscountSection";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import RifleSlider from "../../components/RifleSlider/RifleSlider";
import SearchSection from "../../components/SearchSection/SearchSection";

const Home = () => {
    return (
        <div>
            <HeroSlider/>

            <div className="searchWrapper">
                <SearchSection />
            </div>

            <RifleSlider />
            
            <DiscountSection />
        </div>
    );
};

export default Home;